import {ActionTypeEnum} from "../../base/training-literals";
import Highlight from "./highlight";

class Flash extends Highlight {
    constructor(props = {}) {
        super(props);
        this.actionType = props.actionType || ActionTypeEnum.FLASH;
    }

    startSelection() {
        updateFlashSelectionMaterial(true);
        super.startSelection();
    }

    stopSelection() {
        super.stopSelection();
        setTimeout(updateFlashSelectionMaterial, 800, false);
    }

    isActiveOperation(operationName) {
        if (operationName.includes(ActionTypeEnum.HIGHLIGHT) && this.selectionObjectType !== null
            && operationName.includes(this.selectionObjectType)) {
            return true;
        }
        return false;
    }
}

export default Flash;